import { render, staticRenderFns } from "./ThgLogin.vue?vue&type=template&id=1262ef1e&"
import script from "./ThgLogin.vue?vue&type=script&lang=ts&"
export * from "./ThgLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports